import * as React from "react";
const NewsDeleteWhite = (props) => (
  <svg
    width={12}
    height={15}
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C4.20113 0 2.74286 1.4837 2.74286 3.31394V3.48836H0.514286C0.230254 3.48836 0 3.72263 0 4.01161C0 4.3006 0.230254 4.53487 0.514286 4.53487H11.4857C11.7697 4.53487 12 4.3006 12 4.01161C12 3.72263 11.7697 3.48836 11.4857 3.48836H9.25714V3.31394C9.25714 1.4837 7.79887 0 6 0ZM6 1.04651C7.23081 1.04651 8.22857 2.06167 8.22857 3.31394V3.48836H3.77143V3.31394C3.77143 2.06167 4.76919 1.04651 6 1.04651Z"
      fill="white"
    />
    <path
      d="M1.71198 5.35746C1.68511 5.06977 1.43411 4.85871 1.15136 4.88605C0.868596 4.91338 0.661154 5.16876 0.68802 5.45645C0.752799 6.15013 0.869709 7.00484 1.01999 8.1035L1.21305 9.51495C1.39762 10.8648 1.50229 11.6303 1.72875 12.2574C2.1502 13.4245 2.90198 14.3601 3.86884 14.7752C4.39387 15.0006 4.99441 15.0003 5.88845 15H6.11155C7.00558 15.0003 7.60613 15.0006 8.13116 14.7752C9.09802 14.3601 9.8498 13.4245 10.2712 12.2574C10.4977 11.6303 10.6024 10.8647 10.787 9.51491L10.98 8.10351C11.1303 7.00485 11.2472 6.15013 11.312 5.45645C11.3388 5.16876 11.1314 4.91338 10.8486 4.88605C10.5659 4.85871 10.3149 5.06977 10.288 5.35746C10.2256 6.02581 10.1119 6.85813 9.95956 7.97167L9.77967 9.2868C9.58045 10.7433 9.48922 11.3885 9.30578 11.8965C8.95203 12.8761 8.3638 13.5394 7.73127 13.811C7.42256 13.9435 7.04857 13.9534 6 13.9534C4.95143 13.9534 4.57744 13.9435 4.26873 13.811C3.6362 13.5394 3.04797 12.8761 2.69422 11.8965C2.51078 11.3885 2.41955 10.7433 2.22033 9.28681L2.04044 7.97168C1.88813 6.85813 1.77439 6.02581 1.71198 5.35746Z"
      fill="white"
    />
  </svg>
);
export default NewsDeleteWhite;
